import GradingPoliciesVM from './grading-policies-vm';

export default {
  init() {
    const data = $('#course_json').val();
    ko.applyBindingsWithValidation(new GradingPoliciesVM(data), document.getElementById('js-grading-policies'), Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  }
};
